App.Routers.BeConcept = Backbone.Router.extend({
  routes: {
    '': 'index',
  },

  index: function () {
    // Default route handler
  },
});
